import { useState, createContext, useEffect, ReactNode } from 'react';
import { SolConfig } from '@/types/bbsol';
import { getbbSolConfig } from '@/services/bbysol';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';

export const BbSolConfigContext = createContext<{
  isFetching: boolean;
  solConfig: SolConfig;
}>({
  isFetching: true,
  solConfig: {
    dapps: [],
    exchange: [],
    partners: [],
    apy: 0,
    tvl: 0,
    baseApy: 0,
    boostApy: 0,
    entrance: false,
    ratioYMin: '1',
    ratioYMax: '1.05',
    airdropConfig: [],
  },
});

BbSolConfigContext.displayName = 'BbSolConfigContext';

interface Props {
  children: ReactNode;
}

export const BbSolConfigProvider = (props: Props) => {
  const { children } = props;
  const [solConfig, setSolConfig] = useState<SolConfig>({} as SolConfig);
  const [isFetching, setIsFetching] = useState(true);

  const fetchData = async () => {
    const { result } = await getbbSolConfig();

    setSolConfig(result);
    setIsFetching(false);
  };
  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: 'StakingWeb_BBSOLhomepage',
    });
    document?.body?.scrollTo(0, 0);
    fetchData();
  }, []);

  return (
    <BbSolConfigContext.Provider value={{ isFetching, solConfig }}>
      {children}
    </BbSolConfigContext.Provider>
  );
};
